import { _addEventListener } from "../Helpers/eventHelper";
import Modal from "../Helpers/UI/Modal";
import {
    addParameterToUrl,
    copyToClipboard,
    isUserLoggedIn,
    redirectTo,
    blockScroll,
    unblockScroll,
} from "../Helpers/helpers";
import Message from "../Helpers/UI/Message";
import { getMessage } from "../Helpers/Datas/messages";
import Wishlist from "./Models/Wishlist";
import AddToWishlistModal from "./Modals/AddToWishlistModal";
import ChangeSizeModal from "./Modals/ChangeSizeModal";

export const handlers = {
    wishlistLinkClick(event, link) {
        event.preventDefault();
        if (!isUserLoggedIn()) {
            redirectTo(link.href);
            return;
        }
        const accountTabs = document.querySelector(".account-tabs");
        if (!accountTabs) {
            redirectTo("/account#wishlists");
            return;
        }
        if (link.classList.contains("mobile-menu__item")) {
            window.location.reload();
            return;
        }
        accountTabs?.querySelector('a[href="#wishlists"]').click();
    },

    initializeWishlistLink() {
        const wishlistLinks = document.querySelectorAll("[data-js-wishlist-link]");
        wishlistLinks.forEach((link) => {
            _addEventListener(link, "click", (event) => this.wishlistLinkClick(event, link));
        });
    },

    async chooseAndExecuteActionOnProduct() {
        await this.createWishlist((response) => {
            this.addToWishlistModal.wishlistsInVariantNewState.push(response.id);
        });
        await Promise.all(
            this.addToWishlistModal.wishlistsInVariantNewState
                .filter((wishlistId) => !this.addToWishlistModal.wishlistsInVariantCurrentState.includes(wishlistId))
                .map(async (wishlistId) => {
                    await this.addVariant(
                        this.activeWishlistItem.variantId,
                        this.activeWishlistItem.productId,
                        wishlistId
                    );
                })
        );
        await Promise.all(
            this.addToWishlistModal.wishlistsInVariantCurrentState
                .filter((wishlistId) => !this.addToWishlistModal.wishlistsInVariantNewState.includes(wishlistId))
                .map(async (wishlistId) => {
                    await this.removeVariant(this.activeWishlistItem.variantId, wishlistId, false);
                })
        );
        await this.reinitializeWishlists();
        this.refreshWishlistVariants();
        this.addToWishlistModal.close();
    },

    openAddToWishlistModalAndSynchronizeWishlists(event) {
        const item = event.target.closest("[data-js-wishlist-add-product][data-js-wishlist-add-variant]");
        this.addToWishlistModal.resetInformationAboutWishlists();
        this.activeWishlistItem = {
            variantId: parseInt(item.dataset.jsWishlistAddVariant),
            productId: parseInt(item.dataset.jsWishlistAddProduct),
        };
        this.updateWishlistsForVariant();
        const rect = item.getBoundingClientRect();
        let x = rect.left;
        let y = parseInt(event.pageY + 15);
        this.addToWishlistModal.setPosition(x, y);
        this.addToWishlistModal.show();
    },

    createWishlistHandle(event) {
        event.preventDefault();
        this.createWishlist((response) => {
            Modal.getModalByName("dashboard-popup-new-list").close();
            this.wishlists.unshift(new Wishlist(response));
        });
    },

    showNewWishlistModal(event) {
        event.preventDefault();
        const modal = Modal.getModalByName("dashboard-popup-new-list");
        modal.onClosed = () => {
            unblockScroll();
        };
        modal.show();
        blockScroll();
    },

    closePopups() {
        let modalNames = ["dashboard-popup-new-list", "popup-edit-list", "dashboard-confirmation", "popup-share-list"];
        for (let i = 0; i < modalNames.length; i++) {
            Modal.getModalByName(modalNames[i]).close();
        }
        AddToWishlistModal.getModalByName("wishlist").close();
        ChangeSizeModal.getModalByName("change-size").close();
    },

    backToWishlistsList(event) {
        this.reinitializeWishlistListView();
        window.history.pushState(
            { url: window.location.origin + window.location.pathname },
            document.title,
            window.location.origin + window.location.pathname
        );
    },

    async showProducts(event) {
        const wishlistId = this.wishlist.id;
        addParameterToUrl("wishlist_id", wishlistId);
        await this.reinitializeWishlists();
        this.setCurrentWishlist();
        event.target.classList.add("highlighted");
    },

    migrateWishlists(event) {
        const jsonData = {
            new_token: this.wishlistApi.apiHelper.getUserLoggedApiToken(),
            wishlists: this.migratableWishlists,
        };
        this.wishlistApi.migrateWishlists(
            jsonData,
            async (response) => {
                await this.reinitializeWishlists();
                this.migratableWishlists = [];
            },
            () => {}
        );
    },

    closeMigrationWishlistPopup(event) {
        this.migratableWishlists = [];
    },

    renderChangeSize(event) {
        const variantNode = event.target.closest("[data-js-wishlist-variant]");
        this.selectVariant(variantNode.dataset.jsWishlistVariant);
        if (this.selectedVariant.options) {
            this.changeSizeModal.renderSizeOptions(this.selectedVariant.options);
            this.changeSizeModal.show();
        }
    },

    submitChangeSizeHandle(event) {
        event.preventDefault();
        this.changeProductVariant({
            ...this.selectedVariant.options,
            ...this.changeSizeModal.sizeOptions,
        });
    },

    showEditWishlistModal(event) {
        const modal = Modal.getModalByName("popup-edit-list");
        modal.onOpened = () => blockScroll();
        modal.onClosed = () => unblockScroll();
        const wishlist = event.target.closest("[data-js-wishlist-id]");
        const wishlistId = wishlist.dataset.jsWishlistId;
        this.setCurrentWishlist(wishlistId, false);
        this.newWishlistName = this.currentWishlist.label;
        modal.show();
    },

    changeWishlistNameHandle(event) {
        event.preventDefault();
        const popupWishlist = Modal.getModalByName("popup-edit-list");
        this.validateElements(popupWishlist.getModalElement());
        if (this.valid) {
            const wishlistId = this.currentWishlist.id;
            this.editWishlist((response) => {
                this.getWishlistById(parseInt(wishlistId)).label = this.newWishlistName;
                popupWishlist.close();
                this.newWishlistName = "";
            });
        }
    },

    addSelectedVariantToCartFromWishlist() {
        this.$store.cart.addToCart({ id: this.variant.id }).then(() => {
            Message.displayMessage(getMessage("wishlist.productCartAdded"), "wishlist", "success");
        });
    },

    removalConfirmationFormSubmitHandle() {
        const confirmationPopup = Modal.getModalByName("dashboard-confirmation");
        const removeType = confirmationPopup.getModalElement().dataset.removeType;
        const wishlistId = this.currentWishlist.id;
        if (removeType === "wishlist") {
            this.removeWishlist(wishlistId);
        } else {
            this.variantsChecked.forEach((variantId) => {
                this.removeVariant(variantId);
            });
        }
        confirmationPopup.close();
        this.variantsChecked = [];
    },

    renderRemoveWishlistConfirmationModal(event) {
        const confirmationPopup = Modal.getModalByName("dashboard-confirmation");
        if (!confirmationPopup.getModalElement()) {
            return;
        }
        this.setCurrentWishlist(event.target.closest("[data-js-wishlist-id]").dataset.jsWishlistId, false);
        confirmationPopup.getModalElement().dataset.removeType = "wishlist";
        confirmationPopup.show();
    },

    removeVariantFromWishlist(event) {
        const confirmationPopup = Modal.getModalByName("dashboard-confirmation");
        if (!confirmationPopup.getModalElement()) {
            return;
        }
        this.variantsChecked = [];
        this.variantsChecked.push(event.target.closest("[data-js-wishlist-product]").dataset.jsWishlistVariant);

        confirmationPopup.getModalElement().dataset.removeType = "product";
        confirmationPopup.show();
    },

    showListActions(event) {
        const actionsDropdown = event.target.parentNode.querySelector("[data-js-wishlist-list-actions]");
        if (actionsDropdown) {
            if (actionsDropdown.classList.contains("opened")) {
                actionsDropdown.classList.remove("opened");
            } else {
                this.hideDropdowns();
                actionsDropdown.classList.add("opened");
            }
        }
    },

    async addAllAvailableVariantsFromWishlistToCart() {
        let items = this.wishlist.variants
            .filter((variant) => variant.isAvailable())
            .map((variant) => ({ id: variant.id }));
        await this.$store.cart.addToCart({ items });
        await this.reinitializeWishlists();
        Message.displayMessage(getMessage("wishlist.productCartAdded"), "wishlist", "success");
    },

    /* Add all selected products to Cart */
    addToCartAllSelectedProducts(event) {
        const wishlistNode = event.target.closest("[data-js-wishlist-id]");
        if (wishlistNode && this.variantsChecked.length > 0) {
            if (
                this.variantsChecked.every((variantId) =>
                    this.getVariantFromCurrentWishlistById(variantId).isAvailable()
                )
            ) {
                let items = this.variantsChecked.map((variantId) => ({ id: variantId }));
                this.$store.cart.addToCart({ items }).then(() => {
                    Message.displayMessage(getMessage("wishlist.productCartAdded"), "wishlist", "success");
                });
            } else {
                Message.displayMessage(getMessage("wishlist.outOfStockInfo"), "wishlist", "error");
            }
        }
    },

    removeAllSelectedVariants(event) {
        event.preventDefault();
        const confirmationPopup = Modal.getModalByName("dashboard-confirmation");
        confirmationPopup.getModalElement().dataset.removeType = "product-all";
        confirmationPopup.show();
    },

    shareWishlistHandle(event) {
        if (!Modal.getModalByName("popup-share-list").getModalElement()) {
            return;
        }
        const popupShare = Modal.getModalByName("popup-share-list");
        popupShare.onOpened = () => blockScroll();
        popupShare.onClosed = () => unblockScroll();
        const wishlistNode = event.target.closest("[data-js-wishlist-id]");
        const wishlistId = wishlistNode.dataset.jsWishlistId;
        this.sharedLink = window.location.origin + "/pages/shared-wishlists/?wishlist_id=" + wishlistId + "&share=1";
        popupShare.show();
        this.shareWishlist(wishlistId);
    },

    duplicateSharedWishlist() {
        if (this.currentWishlist.share) {
            this.newWishlistName = this.currentWishlist.label;
            this.createWishlist((wishlist) => {
                this.currentWishlist.variants.forEach((variant) => {
                    this.addVariant(variant.id, wishlist.id);
                });
            });
        }
    },

    copyToClipboardHandle(event) {
        event.preventDefault();
        if (this.sharedLink) {
            copyToClipboard(
                this.sharedLink,
                () => {
                    Message.displayMessage(getMessage("wishlist.copiedToClipboard"), "wishlist", "success");
                },
                () => {
                    Message.displayMessage(getMessage("wishlist.noCopyToClipboard"), "wishlist", "error");
                }
            );
        }
    },
    checkAllVariantsInWishlist(event) {
        this.variantsChecked =
            event.target.checked && this.isDetail ? this.currentWishlist.variants.map((item) => item.id) : [];
    },
};
